import { Reducer } from "redux";
import LocalStorageConst from "../../blocks/consts/LocalStorageConst";
import LocalStorageUtility from "../../blocks/utils/local-storage-utility";
import { TRAFFIC_AREAS_CACHE_TTL } from "../../config";
import Coupon from "../../models/coupon/Coupon";
import { TrafficArea } from "../../models/tariff/trafficAreas/TrafficArea";
import { TrafficAreaGeography } from "../../models/tariff/trafficAreas/TrafficAreaGeography";
import { GetTrafficAreasActionTypes, GetTrafficAreasGeographyActionTypes, SearchCouponsActionTypes } from "./types";

export interface TariffState {
    couponsSearchResult?: Coupon[];
    trafficAreas?: TrafficArea[];
    trafficAreasGeography?: TrafficAreaGeography[];
}

const unloadedState: TariffState = { couponsSearchResult: undefined, trafficAreas: undefined, trafficAreasGeography: LocalStorageUtility.getWithExpiry<TrafficAreaGeography[]>(LocalStorageConst.TrafficAreasGeography) };

export const tariffReducer: Reducer<TariffState> = (state: TariffState | undefined, action): TariffState => {
    if (!state) {
        return unloadedState;
    }

    switch (action.type) {
        case SearchCouponsActionTypes.SUCCESS:
            return { ...state, couponsSearchResult: [...action.payload] };
        case GetTrafficAreasActionTypes.SUCCESS:
            return { ...state, trafficAreas: [...action.payload] };
        case GetTrafficAreasGeographyActionTypes.SUCCESS:
            LocalStorageUtility.setWithExpiry(LocalStorageConst.TrafficAreasGeography, [...action.payload], TRAFFIC_AREAS_CACHE_TTL);
            return { ...state, trafficAreasGeography: [...action.payload] };
        default:
            return state;
    }
};
